import { render, staticRenderFns } from "./safe-space-concerns.vue?vue&type=template&id=25d4f7c6"
import script from "./safe-space-concerns.vue?vue&type=script&lang=js"
export * from "./safe-space-concerns.vue?vue&type=script&lang=js"
import style0 from "./safe-space-concerns.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports